module.exports = __webpack_public_path__ + "static/media/register.1bfebd1b.png";